import { Avatar, Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import RowContainer from "./RowContainer";
import ColumnContainer from "./ColumnContainer";
import { AttachFileRounded } from "@mui/icons-material";
import { handleDownloadClick } from "../../utils/helpers/downloadFile";
import moment from "moment";

import { FormattedMessage } from "react-intl";
import { useAuth } from "../../utils/hooks/useAuth";
import { FormatDateTime } from "../../utils/helpers/FormatDateTime";

export const ChatComponent = ({ element, generalData }) => {
  return (
    <RowContainer
      className={`chat-ticket ${element?.role}`}
      minGap
      align="end"
      style={{ justifyContent: "flex-start" }}
    >
      {element?.role === "user" ? <Avatar></Avatar> : null}

      <Box>
        <Stack spacing={2}>
          <ColumnContainer minGap style={{ padding: "1rem" }}>
            <RowContainer start noGap style={{ gap: "3px" }}>
              <Typography
                variant="h6"
                component="h6"
                className={`sender-info ${element?.role}`}
              >
                {element?.role === "admin" ? (
                  "Admin"
                ) : (
                  <FormattedMessage id="users.singleUser" />
                )}
                , {moment(element?.created_at).format("DD/MM/ YYYY, HH:mm")}
              </Typography>
            </RowContainer>
            {element.message ? (
              <Typography
                variant="p"
                component="p"
                noMargin
                dangerouslySetInnerHTML={{ __html: element.message }}
              ></Typography>
            ) : null}

            {element?.file?.id ? (
              <Tooltip title={<FormattedMessage id="tooltip.downloadFile" />}>
                <Chip
                  className="chip-ticket-attachment"
                  label={
                    <RowContainer start noGap align="center">
                      <AttachFileRounded />
                      {element?.file?.file_name}
                    </RowContainer>
                  }
                  onClick={() =>
                    handleDownloadClick(
                      true,
                      generalData.user_id,
                      element?.file?.id,
                      element?.id,
                      true
                    )
                  }
                  variant="p"
                  component="p"
                />
              </Tooltip>
            ) : null}
          </ColumnContainer>
        </Stack>
      </Box>
    </RowContainer>
  );
};
